"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _stores = require("@seedlang/stores");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var WORD_CARD_TYPES = ['vocab_word_comprehend', 'vocab_word_options', 'vocab_word_translate'];
var SENTENCE_CARD_TYPES = ['vocab_sentence_comprehend', 'comprehend', 'translate'];
var CARD_TYPE_OPTIONS = {
  trivia: null,
  exercise: null,
  user_submission: null,
  conjugation: WORD_CARD_TYPES,
  vocab_word_comprehend: WORD_CARD_TYPES,
  vocab_word_options: WORD_CARD_TYPES,
  gender: WORD_CARD_TYPES,
  vocab_word_translate: WORD_CARD_TYPES,
  plural: WORD_CARD_TYPES,
  vocab_sentence_comprehend: SENTENCE_CARD_TYPES,
  comprehend: SENTENCE_CARD_TYPES,
  vocab_sentence_translate: (0, _lodash.union)(SENTENCE_CARD_TYPES, ['vocab_sentence_translate']),
  translate: SENTENCE_CARD_TYPES
};
var CardTypeSelectWrapper = function CardTypeSelectWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this$props$card$card, _this$props$card2, _this$cardType;
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "cardTypeId", _descriptor, _this);
      _this.onSelectCardType = function (val) {
        _this.cardTypeId = val;
        if ((0, _lodash.isFunction)(_this.props.onChange)) {
          _this.props.onChange(val);
        } else {
          _this.updateCardType([val]);
        }
      };
      _this.updateCardType = function (cardType) {
        if (cardType[0] === _this.props.card.cardTypeId) {
          return;
        }
        if ((0, _lodash.isFunction)(_this.props.onChangeCardTypeId)) {
          _this.props.onChangeCardTypeId(cardType[0]);
        } else {
          var _this$props$card;
          _this.props.card.set('cardTypeId', cardType[0]);
          (_this$props$card = _this.props.card) === null || _this$props$card === void 0 || _this$props$card.set('cardTypeName', _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
            return item.id === cardType[0];
          }).name);
          _stores.CardStore.update({
            ids: {
              cardId: _this.props.card.id
            },
            data: {
              card_type_id: cardType[0]
            }
          }, _lodash.noop);
        }
        _this.cardTypeId = _this.props.card.cardTypeId;
      };
      if (!_state.AppUI.cardTypeStore.hasIndexData) {
        _state.AppUI.cardTypeStore.getIndex({
          filters: {
            allow_reviews: true
          },
          sort: 'name'
        });
      }
      _this.cardTypeId = (_this$props$card$card = (_this$props$card2 = _this.props.card) === null || _this$props$card2 === void 0 ? void 0 : _this$props$card2.cardTypeId) !== null && _this$props$card$card !== void 0 ? _this$props$card$card : (_this$cardType = _this.cardType) === null || _this$cardType === void 0 ? void 0 : _this$cardType.id;
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "resolvedCardTypeId",
      get: function get() {
        var _this$props$card$card2, _this$props$card3, _this$props$cards, _this$cardTypeId, _this$cardType2;
        var fromCard = (_this$props$card$card2 = (_this$props$card3 = this.props.card) === null || _this$props$card3 === void 0 ? void 0 : _this$props$card3.cardTypeId) !== null && _this$props$card$card2 !== void 0 ? _this$props$card$card2 : (_this$props$cards = this.props.cards) === null || _this$props$cards === void 0 || (_this$props$cards = _this$props$cards[0]) === null || _this$props$cards === void 0 ? void 0 : _this$props$cards.cardTypeId;
        if ((0, _utils.isPresent)(this.cardTypeId) && this.cardTypeId !== fromCard) {
          return this.cardTypeId;
        }
        if ((0, _utils.isPresent)(fromCard)) {
          return fromCard;
        }
        return (_this$cardTypeId = this.cardTypeId) !== null && _this$cardTypeId !== void 0 ? _this$cardTypeId : (_this$cardType2 = this.cardType) === null || _this$cardType2 === void 0 ? void 0 : _this$cardType2.id;
      }
    }, {
      key: "isNoun",
      get: function get() {
        if (this.props.card) {
          var _this$props$card$word;
          return (_this$props$card$word = this.props.card.word) === null || _this$props$card$word === void 0 ? void 0 : _this$props$card$word.isNoun;
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            var _item$word;
            return (_item$word = item.word) === null || _item$word === void 0 ? void 0 : _item$word.isNoun;
          }));
        }
      }
    }, {
      key: "isVerb",
      get: function get() {
        if (this.props.card) {
          var _this$props$card$word2;
          return (_this$props$card$word2 = this.props.card.word) === null || _this$props$card$word2 === void 0 ? void 0 : _this$props$card$word2.isVerb;
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            var _item$word2;
            return (_item$word2 = item.word) === null || _item$word2 === void 0 ? void 0 : _item$word2.isVerb;
          }));
        }
      }
    }, {
      key: "hideFromPluralTrainer",
      get: function get() {
        if (this.props.card) {
          var _this$props$card$word3;
          return (_this$props$card$word3 = this.props.card.word) === null || _this$props$card$word3 === void 0 ? void 0 : _this$props$card$word3.hideFromPluralTrainer;
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            var _item$word3;
            return (_item$word3 = item.word) === null || _item$word3 === void 0 ? void 0 : _item$word3.hideFromPluralTrainer;
          }));
        }
      }
    }, {
      key: "hideFromConjugationTrainer",
      get: function get() {
        if (this.props.card) {
          var _this$props$card$word4;
          return (_this$props$card$word4 = this.props.card.word) === null || _this$props$card$word4 === void 0 ? void 0 : _this$props$card$word4.hideFromConjugationTrainer;
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            var _item$word4;
            return (_item$word4 = item.word) === null || _item$word4 === void 0 ? void 0 : _item$word4.hideFromConjugationTrainer;
          }));
        }
      }
    }, {
      key: "hideFromGenderTrainer",
      get: function get() {
        if (this.props.card) {
          var _this$props$card$word5;
          return (_this$props$card$word5 = this.props.card.word) === null || _this$props$card$word5 === void 0 ? void 0 : _this$props$card$word5.hideFromGenderTrainer;
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            var _item$word5;
            return (_item$word5 = item.word) === null || _item$word5 === void 0 ? void 0 : _item$word5.hideFromGenderTrainer;
          }));
        }
      }
    }, {
      key: "verbsFullyReviewed",
      get: function get() {
        if (this.props.card) {
          var _this$props$card$word6;
          return (_this$props$card$word6 = this.props.card.word) === null || _this$props$card$word6 === void 0 ? void 0 : _this$props$card$word6.reviewed2;
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            var _item$word6;
            return (_item$word6 = item.word) === null || _item$word6 === void 0 ? void 0 : _item$word6.reviewed2;
          }));
        }
      }
    }, {
      key: "isUserSubmission",
      get: function get() {
        if (this.props.card) {
          return this.props.card.userSubmission;
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            return item.userSubmission;
          }));
        }
      }
    }, {
      key: "hasCustomText",
      get: function get() {
        if (this.props.card) {
          return (0, _utils.isPresent)(this.props.card.frontText) && (0, _utils.isPresent)(this.props.card.backText);
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            return (0, _utils.isPresent)(item.frontText) && (0, _utils.isPresent)(item.backText);
          }));
        }
      }
    }, {
      key: "cardType",
      get: function get() {
        if (this.props.card) {
          return this.props.card.cardType;
        }
        if (this.props.cards) {
          var cardTypes = [];
          this.props.cards.forEach(function (item) {
            if (cardTypes.map(function (cardType) {
              return cardType.id;
            }).includes(item.cardTypeId)) {
              cardTypes.push(item.cardType);
            }
          });
          if (cardTypes.length === 1) {
            return cardTypes[0];
          }
          return null;
        }
      }
    }, {
      key: "baseOptions",
      get: function get() {
        if (this.props.card) {
          var _this$props$card$card3;
          return (0, _lodash.clone)(CARD_TYPE_OPTIONS[(_this$props$card$card3 = this.props.card.cardType) === null || _this$props$card$card3 === void 0 ? void 0 : _this$props$card$card3.slug]);
        }
        if (this.props.cards) {
          var cardTypeOptions = [];
          this.props.cards.forEach(function (item) {
            var _item$cardType;
            if ((_item$cardType = item.cardType) !== null && _item$cardType !== void 0 && _item$cardType.slug) {
              var _item$cardType2;
              cardTypeOptions.push((0, _lodash.clone)(CARD_TYPE_OPTIONS[(_item$cardType2 = item.cardType) === null || _item$cardType2 === void 0 ? void 0 : _item$cardType2.slug]));
            }
          });
          return (0, _lodash.flatten)(_lodash.intersection.apply(void 0, cardTypeOptions));
        }
      }
    }, {
      key: "hasSentence",
      get: function get() {
        if (this.props.card) {
          return (0, _utils.isPresent)(this.props.card.sentence);
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            return (0, _utils.isPresent)(item.sentence);
          }));
        }
      }
    }, {
      key: "hasSentenceVideoClip",
      get: function get() {
        if (this.props.card) {
          var _this$props$card$sent;
          return (0, _utils.isPresent)((_this$props$card$sent = this.props.card.sentence) === null || _this$props$card$sent === void 0 || (_this$props$card$sent = _this$props$card$sent.target) === null || _this$props$card$sent === void 0 ? void 0 : _this$props$card$sent.videoClip);
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            var _item$sentence;
            return (0, _utils.isPresent)((_item$sentence = item.sentence) === null || _item$sentence === void 0 || (_item$sentence = _item$sentence.target) === null || _item$sentence === void 0 ? void 0 : _item$sentence.videoClip);
          }));
        }
      }
    }, {
      key: "wordHasPluralForms",
      get: function get() {
        if (this.props.card) {
          var w = this.props.card.word;
          return Boolean(w && !w.noPlural);
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            return item.word && !item.word.noPlural;
          }));
        }
      }
    }, {
      key: "hasValidGenderForTrainer",
      get: function get() {
        if (this.props.card) {
          var w = this.props.card.word;
          return Boolean(w && !w.invalidGender);
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            return item.word && !item.word.invalidGender;
          }));
        }
      }
    }, {
      key: "hasConjugationStrings",
      get: function get() {
        if (this.props.card) {
          var _w$conjugatedVerbStri;
          var w = this.props.card.word;
          return Boolean(w === null || w === void 0 || (_w$conjugatedVerbStri = w.conjugatedVerbStrings) === null || _w$conjugatedVerbStri === void 0 ? void 0 : _w$conjugatedVerbStri.length);
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            var _item$word7;
            return (_item$word7 = item.word) === null || _item$word7 === void 0 || (_item$word7 = _item$word7.conjugatedVerbStrings) === null || _item$word7 === void 0 ? void 0 : _item$word7.length;
          }));
        }
      }
    }, {
      key: "hasWord",
      get: function get() {
        if (this.props.card) {
          return (0, _utils.isPresent)(this.props.card.word);
        }
        if (this.props.cards) {
          return (0, _lodash.every)(this.props.cards.map(function (item) {
            return (0, _utils.isPresent)(item.word);
          }));
        }
      }
    }, {
      key: "languageId",
      get: function get() {
        if (this.props.card) {
          var _this$props$card$word7;
          return (_this$props$card$word7 = this.props.card.word) === null || _this$props$card$word7 === void 0 ? void 0 : _this$props$card$word7.languageId;
        }
        if (this.props.cards) {
          return this.props.cards.map(function (item) {
            var _item$word8;
            return (_item$word8 = item.word) === null || _item$word8 === void 0 ? void 0 : _item$word8.languageId;
          })[0];
        }
      }
    }, {
      key: "slugIsEligible",
      value: function slugIsEligible(slug) {
        var _this$cardType3;
        switch (slug) {
          case 'vocab_word_comprehend':
          case 'vocab_word_options':
          case 'vocab_word_translate':
            return this.hasWord;
          case 'vocab_sentence_comprehend':
          case 'comprehend':
            return this.hasSentence && this.hasSentenceVideoClip;
          case 'translate':
          case 'vocab_sentence_translate':
            return this.hasSentence;
          case 'gender':
            return this.isNoun && !this.hideFromGenderTrainer && this.hasValidGenderForTrainer;
          case 'plural':
            return this.isNoun && !this.hideFromPluralTrainer && this.languageId === 'DE' && this.wordHasPluralForms;
          case 'conjugation':
            return this.isVerb && !this.hideFromConjugationTrainer && this.verbsFullyReviewed && this.hasConjugationStrings;
          case 'user_submission':
            return ((_this$cardType3 = this.cardType) === null || _this$cardType3 === void 0 ? void 0 : _this$cardType3.slug) === 'user_submission' || this.isUserSubmission || this.hasCustomText;
          default:
            return true;
        }
      }
    }, {
      key: "cardTypeOptions",
      get: function get() {
        var _this$cardType4,
          _this2 = this;
        var options = this.baseOptions;
        if (((_this$cardType4 = this.cardType) === null || _this$cardType4 === void 0 ? void 0 : _this$cardType4.slug) === 'user_submission') {
          if (this.hasWord) {
            options = (0, _lodash.clone)(WORD_CARD_TYPES);
          } else {
            options = ['user_submission'];
          }
        } else if (!(0, _utils.isPresent)(options) && this.hasCustomText) {
          options = ['user_submission'];
        }
        if ((0, _utils.isPresent)(options)) {
          options = (0, _lodash.clone)(options);
          if (this.isNoun && !this.hideFromGenderTrainer) {
            options.push('gender');
          }
          if (this.isNoun && !this.hideFromPluralTrainer && this.languageId === 'DE') {
            options.push('plural');
          }
          if (this.isVerb && !this.hideFromConjugationTrainer && this.verbsFullyReviewed) {
            options.push('conjugation');
          }
          if (this.isUserSubmission || this.hasCustomText) {
            options.push('user_submission');
          }
          var sortedFiltered = (0, _lodash.uniq)(options).filter(function (slug) {
            return _this2.slugIsEligible(slug);
          }).sort();
          return _state.AppUI.cardTypeStore.indexData.filter(function (item) {
            return sortedFiltered.includes(item.slug);
          }).map(function (item) {
            return [item.id, item.name];
          });
        }
        return [];
      }
    }, {
      key: "onlyCustomCardTypeOption",
      get: function get() {
        var _this$cardType5;
        if (!this.props.card) {
          return false;
        }
        return !this.hasWord && ((_this$cardType5 = this.cardType) === null || _this$cardType5 === void 0 ? void 0 : _this$cardType5.slug) === 'user_submission';
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          cardTypeOptions: this.cardTypeOptions,
          onlyCustomCardTypeOption: this.onlyCustomCardTypeOption,
          updateCardType: this.updateCardType,
          cardTypeId: this.resolvedCardTypeId,
          cardType: this.cardType,
          onSelectCardType: this.onSelectCardType
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "cardTypeId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "resolvedCardTypeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "resolvedCardTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isNoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isNoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isVerb", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isVerb"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hideFromPluralTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hideFromPluralTrainer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hideFromConjugationTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hideFromConjugationTrainer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hideFromGenderTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hideFromGenderTrainer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "verbsFullyReviewed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "verbsFullyReviewed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isUserSubmission", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isUserSubmission"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasCustomText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasCustomText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "baseOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "baseOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasSentence"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasSentenceVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasSentenceVideoClip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordHasPluralForms", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordHasPluralForms"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasValidGenderForTrainer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasValidGenderForTrainer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasConjugationStrings", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasConjugationStrings"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "languageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "languageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardTypeOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardTypeOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onlyCustomCardTypeOption", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "onlyCustomCardTypeOption"), _class2.prototype), _class2)) || _class;
};
CardTypeSelectWrapper.displayName = 'CardTypeSelectWrapper';
var _default = exports["default"] = CardTypeSelectWrapper;